import con from '../../../../connection';
var path = '/industries';
export var industries = function (url) { return function (type) { return ({
    get: function () { return con.get(url + path + (type ? "/" + type : ''), {}); },
}); }; };
